<template>
  <v-card class="session-history-container">
    <v-card-title style="background-color: #eeeeee"
      >Session History
      <div class="loading-holder">
        <v-progress-circular
          v-if="this.loading"
          indeterminate
          color="primary"
        ></v-progress-circular></div
    ></v-card-title>

    <v-card-text>
      <v-list three-line>
        <v-list-item v-for="(item, index) in history" :key="index" class="item">
          <v-list-item-icon style="margin: 8px;">
            <v-icon v-if="item.newStatus === 'approved'" class="approv" large
              >mdi-thumb-up</v-icon
            >
            <v-icon
              v-else-if="item.newStatus === 'disavowed'"
              class="disav"
              large
              >mdi-thumb-down</v-icon
            >
            <v-icon
              v-else-if="item.newStatus === 'unassigned'"
              class="unassigned"
              large
              >mdi-alert-circle</v-icon
            >
            <v-icon v-else-if="item.type === 'assignee'" class="assign" large
              >mdi-account</v-icon
            >
            <v-icon v-else-if="item.type === 'bulk-assign'" class="assign" large
              >mdi-account</v-icon
            >

            <v-icon v-else class="rev" large>mdi-help-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-if="item">{{
              computedTitle(item)
            }}</v-list-item-title>

            <v-list-item-title v-else>{{ item.oldStatus }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ computedDescription(item) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action
            ><v-btn block depressed @click="undo(index, item)">
              Undo
            </v-btn></v-list-item-action
          >
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      test: false,
    };
  },

  /*
  
  Setup the session history by letting setDisavowStatus, and setDisavowStatusBulk.
  When calling those functions call another function called sessionHistoryHandler()
  Pass in the link(s) and in the sessionHistoryHandler determine if its an array or 1 single link
  create a copy of the state they are current in and save it and then change the current link(s)
  The undo button will call a function that just sets the link(s) to their previous state.

  -- STAY TUNED FOR UPLOAD SESSION HISTORY --

  */
  methods: {
    groupsToString(item) {
      let result = "";
      item.groups.forEach((elem) => {
        result += elem;
        result += ", ";
      });
      result = result.substring(0, result.length - 2);
      return result;
    },

    //Computes a different string for the description of the session history block depending on the type of change
    // i.e single group or bulk group action
    computedDescription(item) {
      let descriptionString;
      if (item.type === "bulk") {
        let groupURLs = [];
        item.groups.forEach((item) => {
          groupURLs.push(item.group);
        });

        descriptionString = groupURLs;
      } else if (item.type === "single") {
        descriptionString = item.group.group;
      } else if (item.type === "assignee") {
        descriptionString = "Assigned to -> " + item.newStatus.name;
      } else if (item.type === "single-link") {
        descriptionString = item.link.url;
      } else if (item.type === "bulk-link") {
        let linkURLs = [];
        console.log(item);
        item.urls.forEach((item) => {
          console.log(item);
          linkURLs.push(item.url);
        });

        descriptionString = linkURLs;
        console.log(item.urls);
      } else if (item.type === "bulk-assign") {
        descriptionString = "Assigned to -> " + item.newAssignee;
      }

      return descriptionString;
    },

    computedTitle(item) {
      console.log(item);
      if (item.groups) {
        return "" + item.groups.length + " Groups " + item.newStatus;
      } else if (item.group) {
        return "Group " + item.newStatus;
      } else if (item.type === "assignee") {
        return item.groupItem.group;
      } else if (item.type === "single-link") {
        console.log(item);
        return "Link " + item.newStatus;
      } else if (item.type === "bulk-link") {
        return "" + item.links.length + " Links " + item.newStatus;
      } else if (item.type === "bulk-assign") {
        return "" + item.newGroups.length + " Groups Assigned";
      }
    },
    undo(index, item) {
      //call api stuff here or in state
      let undoObject = {
        index: index,
        item: item,
      };

      this.loading = true;

      console.log(item);
      console.log(undoObject);
      if (item.type === "single") {
        this.$store.dispatch("sessionHistory/undoChange", undoObject);
      } else if (item.type === "bulk") {
        this.$store.dispatch("sessionHistory/undoChange", undoObject);
      } else if (item.type === "assignee") {
        this.$store.dispatch("sessionHistory/undoChange", undoObject);
      } else {
        this.$store.dispatch("sessionHistory/undoChange", undoObject);
      }
    },
  },
  computed: {
    ...mapGetters({
      history: "sessionHistory/history",
      loading: "sessionHistory/loading",
    }),
  },
};
</script>

<style>
.session-history-container {
  position: relative;
  background-color: teal;
  max-height: 80%;
}
.title {
  text-align: center;
}

.v-icon.approv {
  border: 30px solid green;
  border-radius: 50%;
  height: 56px;
  width: 56px;
}

.v-icon.unassigned {
  border: 30px solid #1976d2;
  border-radius: 50%;
  height: 56px;
  width: 56px;
}

.v-icon.disav {
  border: 30px solid red;
  border-radius: 50%;
  height: 56px;
  width: 56px;
}

.v-icon.assign {
  border: 30px solid purple;
  border-radius: 50%;
  height: 56px;
  width: 56px;
}

.v-icon.rev {
  border: 30px solid yellow;
  border-radius: 50%;
  height: 56px;
  width: 56px;
}

.item {
  padding-left: 2px;
  padding-right: 2px;
}
.loading-holder {
  position: absolute;
  right: 10px;
}
</style>
